import requestFunctions from "../../functions/requestFunctions";


export const state = {
  KNOWLEDGE_ITEM: {},
  KNOWLEDGE_LIST: [],
  KNOWLEDGE_TABLE_DATA: [],
  KNOWLEDGE_LIST_DATA: [],
  KNOWLEDGE_TOTAL_ROWS: 0
}

export const getters = {
  GET_KNOWLEDGE_ITEM: (state) => {
    return state.KNOWLEDGE_ITEM;
  },
  GET_KNOWLEDGE_LIST: (state) => {
    return state.KNOWLEDGE_LIST;
  },
  GET_KNOWLEDGE_TABLE_DATA: (state) => {
    return state.KNOWLEDGE_TABLE_DATA;
  },
  GET_KNOWLEDGE_LIST_DATA: (state) => {
    return state.KNOWLEDGE_LIST_DATA;
  },
  GET_KNOWLEDGE_TOTAL_ROWS: (state) => {
    return state.KNOWLEDGE_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_KNOWLEDGE_ITEM(state, item) {
    state.KNOWLEDGE_ITEM = item;
  },

  UPDATE_KNOWLEDGE_LIST(state, list) {
    
    state.KNOWLEDGE_LIST = list.data;

    state.KNOWLEDGE_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.KNOWLEDGE_TABLE_DATA = [];
    state.KNOWLEDGE_LIST_DATA = [];

    let status = {
      'active': 'Активна',
      'update': 'Обновление',
      'indexing': 'Индексация',
      'error': 'Ошибка'
    }
    
    list.forEach(el => {

      let dev_data = '';

      if(el.dev_profile_fullname !== null){
        dev_data = el.dev_profile_fullname;
      }

      if(el.dev_phone !== null ){
        if(dev_data !== ''){
          dev_data = dev_data + ', ';
        }
        dev_data = dev_data + el.dev_phone;
      }

      state.KNOWLEDGE_TABLE_DATA.push({
        'id': el.id,
        'name' : el.name,
        'link': el.link,
        'description': el.description,
        'dev_data': dev_data,
        'status': status[el.status] ? status[el.status] : null,
        'uuid': el.uuid,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
        'owner_id': el.owner_id,
        'user_id': el.user_id,
      });

      state.KNOWLEDGE_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_KNOWLEDGE_ITEM({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/knowledge/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_KNOWLEDGE_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_KNOWLEDGE_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.client.za-bota.com/v1/knowledge';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_KNOWLEDGE_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_KNOWLEDGE_CREATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/knowledge';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_KNOWLEDGE_UPDATE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/knowledge/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_KNOWLEDGE_DELETE({ commit }, payload) {

    let query_url = 'https://api.client.za-bota.com/v1/knowledge/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}